import { createAsyncThunk } from '@reduxjs/toolkit'
import apiClient from '../../../services/axois'
import { toast } from 'react-toastify'
import { addIdKeyToObject } from '../../../utility/genricFunction'
import { addSequentialNo, convertToReportDate } from '../../../utility/genricFunction'
// this is for demo purpose only / change for further api calls

export const getFeesCollectionReport = createAsyncThunk('reports/getFeesCollectionReport', async (data) => {
  const startDate = convertToReportDate(data.fromDate)
  const endDate = convertToReportDate(data.toDate)
  const branchId = data.branch
  const batchId = data.batch

  try {
    let url = `/report/fees-collection`
    const response = await apiClient.post(url, {
      startDate,
      endDate,
      branchId,
      batchId,
    })

    const modifiedData = response?.data?.result.paymentDetails.map((feesData, index) => {
      return { no: index + 1, ...feesData }
    })

    const totalPaidAmount = response?.data?.result.totalPaidAmount

    return { paymentDetails: modifiedData, totalPaidAmount }
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const getStudentDetailsReport = createAsyncThunk('reports/getStudentDetailsReport', async (data) => {
  try {
    let url = `/report/student-details-report`
    const response = await apiClient.post(url, {
      batchId: data.batch,
      branchId: data.branch,
    })

    const modifiedData = response?.data?.result?.map((studentData, index) => {
      return { no: index + 1, ...studentData }
    })

    return modifiedData
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const getFeesDueDetailsReport = createAsyncThunk('reports/getFeesDueDetailsReport', async (data) => {
  try {
    let url = `/report/fees-collection-due`
    const response = await apiClient.post(url, {
      batchId: data.batch,
      branchId: data.branch,
      month: data.month,
      year: data.year,
    })

    const modifiedData = response?.data?.result?.map((studentData, index) => {
      return { no: index + 1, ...studentData }
    })

    return modifiedData
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const getAttendanceReport = createAsyncThunk('reports/getAttendanceReport', async (data) => {
  try {
    let url = `/report/attendance-report`
    const response = await apiClient.post(url, {
      batchId: data.batch,
      branchId: data.branch,
    })
    // return response?.data?.result;

    const modifiedData = response?.data?.result?.studentAttendanceData?.map((studentData, index) => {
      return { no: index + 1, ...studentData }
    })

    return { studentAttendanceData: modifiedData, batchData: response?.data?.result?.batchData }
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const getExamResultReport = createAsyncThunk('reports/getExamResultReport', async (data) => {
  try {
    let url = `/report/exam-result`
    const response = await apiClient.post(url, {
      batchId: data.batch,
      branchId: data.branch,
    })

    const modifiedData = response?.data?.result?.map((studentData, index) => {
      return { no: index + 1, ...studentData }
    })

    return modifiedData
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const getFacultyLectureReport = createAsyncThunk(
  'reports/getFacultyLectureReport',
  async ({ data, setIsTableOpen }) => {
    const startDate = convertToReportDate(data.fromDate)
    const endDate = convertToReportDate(data.toDate)
    const branchId = data.branch

    try {
      let url = `/report/faculty-lecture-report`
      const response = await apiClient.post(url, {
        startDate,
        endDate,
        branchId,
      })

      setIsTableOpen(true)

      const modifiedData = addSequentialNo(response?.data?.result)
      return modifiedData

      // return response?.data?.result;
    } catch (error) {
      console.error('builder function error:', error)
      throw error
    }
  },
)

export const getFacultyLectureCountReport = createAsyncThunk(
  'reports/getFacultyLectureCountReport',
  async ({ data, setIsTableOpen }) => {
    try {
      let url = `/report/faculty-lecture-report`
      const response = await apiClient.post(url, {
        batchId: data.batch,
        branchId: data.branch,
      })

      const modifiedData = addSequentialNo(response?.data?.result)

      setIsTableOpen(true)

      return modifiedData
    } catch (error) {
      console.error('builder function error:', error)
      throw error
    }
  },
)

export const getBatchFromBranch = createAsyncThunk('branch/get-batch-list', async (branchId) => {
  const url = `/batches?branchId=${branchId}`
  try {
    const response = await apiClient.get(url)
    return response.data.result.batches
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const getCourseFromBranch = createAsyncThunk('reports/get-course-from-branch', async (branchId) => {
  try {
    let url = `/courses?branch=${branchId}&&courseStatus=publish`
    const response = await apiClient.get(url)
    return response?.data?.result.courses
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const getKitDistributionReport = createAsyncThunk(
  'reports/getKitDistributionReport',
  async ({ batchId, branchId }) => {
    try {
      let url = `/report/kit-distribution`
      const response = await apiClient.post(url, {
        batchId,
        branchId,
      })
      const data = response?.data?.result
      return addIdKeyToObject(data)
    } catch (error) {
      console.error('builder function error:', error)
      throw error
    }
  },
)

export const getSourceWiseInquiryReport = createAsyncThunk(
  'reports/getSourceWiseInquiry',
  async ({ startDate, endDate, branchId, courseId }) => {
    try {
      let url = `/report/source-inquiry`
      const response = await apiClient.post(url, {
        branchId,
        startDate,
        endDate,
        courseId,
      })
      const data = response?.data?.result?.sourceList
      return addIdKeyToObject(data)
    } catch (error) {
      console.error('builder function error:', error)
      throw error
    }
  },
)

export const getKitSummaryReport = createAsyncThunk(
  'reports/getKitSummaryReport',
  async ({ branchId, startDate, endDate }) => {
    try {
      let url = `/report/kit-summary`
      const response = await apiClient.post(url, {
        branchId,
        startDate,
        endDate,
      })
      const data = response?.data?.result
      return addIdKeyToObject(data)
    } catch (error) {
      console.error('builder function error:', error)
      throw error
    }
  },
)

export const getTimeTableReport = createAsyncThunk(
  'reports/getTimeTable',
  async ({ branchId, startDate, endDate, faculties }) => {
    try {
      let url = `/report/timetable-report`
      const response = await apiClient.post(url, { branchId, startDate, endDate, faculties })
      return response.data.result
    } catch (error) {
      console.error('builder function error:', error)
      throw error
    }
  },
)

export const getDailyReport = createAsyncThunk('reports/getDailyReport', async ({ Date, branchId }) => {
  try {
    let url = `/report/daily-report`
    const response = await apiClient.post(url, { Date, branchId })
    return response.data.result
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const sendReportMail = createAsyncThunk('reports/sendReportMail', async ({ blob, emailData, type, data }) => {
  try {
    let url = `/report/send-mail`
    const formData = new FormData()
    formData.append('file', blob)
    emailData && formData.append('email', emailData)
    type && formData.append('type', type)
    data && formData.append('data', JSON.stringify(data))
    const response = await apiClient.post(url, formData)

    if (response.status && type !== 'timetable') {
      toast.success(response.data.message, {
        className: 'custom-toast-success',
        progressStyle: { background: '#ffffff' },
      })
    }
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const getInquiryReport = createAsyncThunk(
  'reports/getInquiry',
  async ({ startDate, endDate, branchId, courseId }) => {
    try {
      let url = `/report/inquiry`
      const response = await apiClient.post(url, {
        branchId,
        startDate,
        endDate,
        courseId,
      })
      return response?.data?.result
    } catch (error) {
      console.error('builder function error:', error)
      throw error
    }
  },
)

export const getAreaWiseInquiryReport = createAsyncThunk(
  'reports/getAreaWiseInquiry',
  async ({ startDate, endDate, branchId, courseId }) => {
    try {
      let url = `/report/area-inquiry`
      const response = await apiClient.post(url, {
        branchId,
        startDate,
        endDate,
        courseId,
      })
      return response?.data?.result
    } catch (error) {
      console.error('builder function error:', error)
      throw error
    }
  },
)
